export enum ActionTypeEnums {
	SetPresentedMedia = 'SET_PRESENTED_MEDIA',
	AddPresentedMedia = 'ADD_PRESENTED_MEDIA',
	RemovePresentedMedia = 'REMOVE_PRESENTED_MEDIA',
	SetPresentedMediaVideoState = 'SET_PRESENTED_MEDIA_VIDEOSTATE',
	SetPresentedMediaPage = 'SET_PRESENTED_MEDIA_PAGE',
	RemoveEnabledGraphic = 'REMOVE_ENABLED_GRAPHIC',
	AddAnimatedGraphic = 'ADD_ANIMATED_GRAPHIC',
	SetCurrentShotId = 'SET_CURRENT_SHOT_ID',
	SetClearShot = 'SET_CLEAR_SHOT',
}

// types of reducers in redux front-end
export enum Reducers {
	shots = 'shotsReducer',
	media = 'mediaReducer'
}

// constant for variable labels
export enum EntityType {
	currentShotId = 'currentShotId',
	shotStartTimestamp = 'shotStartTimestamp',
	presentedMedia = 'presentedMedia',
	connectedUsers = 'connectedUsers',
	allShotOverlays = 'allShotOverlays',
	animatedOverlayIds = 'animatedOverlayIds',
	commsToggle = 'commsToggle',
	scheduledStream = 'scheduledStream',
	roomState = 'roomState',
	generatedContent = 'generatedContent',
	overlay = 'overlay',
	media = 'media',
	broadcast = 'broadcast',
	destinations = 'destinations',
	opentokSession = 'opentokSession',
	srtStream = 'srtStream',
	livekitSession = 'livekitSession',
	livekitIngress = 'livekitIngress',
	profileMask = 'profileMask',
	activeMasks = 'activeMasks',
	onsiteLocation = 'onsiteLocation',
	recentSlideDeck = 'recentSlideDeck',
	contentChips = 'contentChips',
}

export enum Timers {
	autoplay = 'autoplay'
}

export enum RoomStates {
	live = 1,
	showbuilder = 2
}

// socket message type property
export enum SocketMessages {
	syncedReduxAction = 'synced-redux-action',
	playShot = 'play-shot',
}

export enum ThumbnailLocation {
	ShotTab = 'shot-tab',
	FeedsTab = 'feeds-tab',
	ShotModal = 'shot-modal',
}